import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import PublicShare from './feature/PublicShare';

export default class App extends React.PureComponent {
  render() {
    return (
      <div className="App">
        {/* <Router>
          <Route path="" component={PublicShare} />
        </Router> */}
        <PublicShare />
      </div>
    );
  }
}
